import { createElement, forwardRef, Ref } from "react"
import DatePicker from "react-datepicker"

import { type FC } from "react"

import "react-datepicker/dist/react-datepicker.css"

type Props = {
  setSelectedDate: (date: [Date | null, Date | null]) => void
  startDate?: Date | null
  endDate?: Date | null
  clearable?: boolean
  maxDate?: Date
  minDate?: Date
  label?: string
}

const CustomInput = (props: React.ComponentProps<"input">, ref: Ref<HTMLInputElement>) => (
  <input {...props} readOnly placeholder="Выберите интервал" className="input-form" ref={ref} />
)

export const RangeCalendar: FC<Props> = ({
  setSelectedDate,
  startDate,
  endDate,
  clearable = false,
  maxDate,
  minDate,
  label
}) => {
  return (
    <fieldset>
      {label && <legend>{label}</legend>}
      <DatePicker
        selected={startDate}
        startDate={startDate}
        endDate={endDate}
        onChange={(date: [Date | null, Date | null]) => setSelectedDate(date)}
        isClearable={clearable}
        maxDate={maxDate}
        minDate={minDate}
        selectsRange
        customInput={createElement(forwardRef(CustomInput))}
        wrapperClassName="width-full"
        monthsShown={2}
        dateFormat="MM/dd/yyyy"
      />
    </fieldset>
  )
}
